const bidStatusMessages = (status: string): string | undefined =>
  ({
    proxy: 'info',
    outbid: 'danger',
    matched: 'warning',
    firstBid: 'success',
    accepted: 'success'
  }[status]);

export default bidStatusMessages;